import DashboardProvider from './DashboardContext';
import Dashboard from './Dashboard';

let Index = () => {
    return (
        <DashboardProvider>
            <Dashboard />
        </DashboardProvider>
    )
}

export default Index;